import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'

type Size = 'text' | 'small' | 'medium' | 'large'

type Color = '_color-primary'

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnChanges {
    @Input() style!: Record<string, any>
    @Input() size: Size = 'text'
    @Input() colorClass: Color = '_color-primary'
    @Input() showMessage = false
    @Input() message = 'Carregando'
    @Input() ngClass!: Record<string, any>
    resolution!: string

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['size']) this.setResolution()
    }

    setResolution() {
        switch (this.size) {
            case 'large':
                this.resolution = '300px'
                break
            case 'medium':
                this.resolution = '200px'
                break
            case 'small':
                this.resolution = '100px'
                break
            case 'text':
                this.resolution = '1rem'
        }
    }
}
